"use strict";

import eventDescriptorStore from "./../store/eventDescriptors";

export default {
	getEventDescriptorFromNotificationConfig,
	isValidEventDescriptor,
	isValidNotificationConfig
};

export {getEventDescriptorFromNotificationConfig as getEventDescriptorFromNotificationConfig};
export {isValidEventDescriptor as isValidEventDescriptor};
export {isValidNotificationConfig as isValidNotificationConfig};

function getEventDescriptorFromNotificationConfig(notificationConfig){
	if(!notificationConfig){
		return null;
	}
	
	return eventDescriptorStore.get(notificationConfig.descriptor);
}

function isValidCriticalScalarStateDescriptor(eventDescriptor){
	let isValid = true;
		
	if( !eventDescriptor ||
		!eventDescriptor.type ||
		eventDescriptor.type != "CriticalScalarStateDescriptor" ||
		!eventDescriptor.carriers || 
		!eventDescriptor.dataType ||
		!eventDescriptor.operator ||
		!Number.isFinite(eventDescriptor.debounceTime) ||
		!eventDescriptor.operands)
	{
		return false;
	}
	
	if(eventDescriptor.carriers.user){
		isValid = isValid && eventDescriptor.carriers.carriers == null;
	}
	else{
		isValid = isValid && eventDescriptor.carriers.carriers.length != 0;
	}
	
	if(eventDescriptor.operator == "between" || eventDescriptor.operator == "notbetween"){
		isValid = isValid && eventDescriptor.operands.length == 2;
	}
	else{
		isValid = isValid && eventDescriptor.operands.length == 1;
	}
	
	isValid = isValid && eventDescriptor.operands.every(e => Number.isFinite(e));
	isValid = isValid && Number.isFinite(eventDescriptor.debounceTime);
	
	return isValid;
}

function isValidPOICrossingDescriptor(eventDescriptor){
	let isValid = true;
		
	if( !eventDescriptor ||
		!eventDescriptor.type ||
		eventDescriptor.type != "POICrossingDescriptor" ||
		!eventDescriptor.carriers || 
		!eventDescriptor.pois)
	{
		return false;
	}
	
	if(eventDescriptor.carriers.user){
		isValid = isValid && eventDescriptor.carriers.carriers == null;
	}
	else{
		isValid = isValid && eventDescriptor.carriers.carriers.length != 0;
	}
	
	if(eventDescriptor.pois.user){
		isValid = isValid && eventDescriptor.pois.pois == null;
	}
	else{
		isValid = isValid && eventDescriptor.pois.pois.length != 0;
	}
	
	isValid = isValid && (eventDescriptor.arriving || eventDescriptor.departing);
	
	return isValid;
}

function isValidEventDescriptor(eventDescriptor){
	return isValidCriticalScalarStateDescriptor(eventDescriptor) || isValidPOICrossingDescriptor(eventDescriptor);
}

function isValidNotificationConfig(notificationConfig){
	return(
		notificationConfig &&
		(notificationConfig.web || notificationConfig.email || notificationConfig.sms)
	);
}


// WEBPACK FOOTER //
// ./src/utils/notification.js